export const BACKEND_URL = window.BACKEND_URL || 'http://localhost:5000'
